// utils/authHelpers.ts
type UserRole = 'landlord' | 'client' | 'admin'

export const redirectToDashboard = (role: UserRole, navigate: (path: string) => void) => {
  if (role === 'landlord') navigate('/dashboard/landlord')
  else if (role === 'client') navigate('/dashboard/client')
  else if (role === 'admin') navigate('/admin/dashboard')
}

export const mapAuthErrorToMessage = (error: { message?: string; status?: number }, action: 'signin' | 'signup'): string => {
  if (error.message?.includes('Invalid login credentials')) return '❌ Invalid email or password.'
  if (error.message?.includes('Email not confirmed')) return '📧 Please confirm your email.'
  if (error.status === 429) return '⏱️ Too many attempts, try again later.'
  if (error.status === 500) return '🚨 Server error, please retry.'
  return `❌ ${action === 'signin' ? 'Sign in' : 'Sign up'} failed: ${error.message}`
}
